
import { Heading, Paragraph } from "@/components/ui/Typography";
import type { MicroSite } from "@/lib/api";
import { sanitizeHtml } from "@/utils/helpers/html";

const Hero = ({data}:{data: MicroSite}) => {


  const PreviewComponent = () => {
    if(!data){
      return null;
    };
    
    return (
      <div className=" relative flex flex-col  w-full min-h-96 xl:min-h-[35rem]">

        <div className="flex p-1 items-center justify-center">
            <img src={data?.branding?.websiteLogoUrl} alt="" className="h-12 object-contain w-fit min-w-fit" />
        </div>
        <div className="h-full flex items-center justify-center relative overflow-hidden flex-1">
          {/* Overlay */}
      <div className="absolute top-0 left-0 w-full h-full bg-black opacity-50 z-10"></div>
      {/* Bg Image */}
        <img src={data?.headerSection?.headerImageUrl ?? "/blank-image-placeholder.png"} alt={"Hero Section"} className="w-full object-cover h-full object-center absolute inset-0 " />

        {/* Title and description */}
        <div className="absolute z-20 items-center justify-center text-center flex flex-col gap-4 w-full px-4 lg:px-16">
        
          <div className="flex items-center gap-3">
          <Heading level={1} className="" style={{color: data?.branding?.textColorCode}}>{data?.headerSection?.headerTitle}</Heading>
          </div>
          <Paragraph dangerouslySetInnerHTML={{ __html: sanitizeHtml(data?.headerSection?.headerDescription ?? "") }} className=" lg:w-1/3" style={{color: data?.branding?.textColorCode}}></Paragraph>
        </div>
        </div>
           
      </div>
    )
  };

  return (
    <div>
       <PreviewComponent />
    </div>
  )
}

export default Hero